module.exports = __webpack_public_path__ + "img/corrugatedBox4.130a9aaf.jpg";